var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from './../common-theme/seo/seo-aware-base.component';
import { Lightbox, LightboxConfig } from 'angular2-lightbox';
import { ListTrackingService } from '../common-theme/utils/list-tracking.service';
var GalleryPageComponent = /** @class */ (function (_super) {
    __extends(GalleryPageComponent, _super);
    function GalleryPageComponent(injector, _lightbox, listTrackingService, _lighboxConfig, window) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this._lightbox = _lightbox;
        _this.listTrackingService = listTrackingService;
        _this._lighboxConfig = _lighboxConfig;
        _this.window = window;
        _this.officeImages = [
            { url: '/assets/images/gallery/office/1.jpeg' },
            { url: '/assets/images/gallery/office/2.jpeg' },
            { url: '/assets/images/gallery/office/3.jpeg' }
        ];
        _this.exteriorImages = [
            { url: '/assets/images/gallery/exterior/1.jpg' },
            { url: '/assets/images/gallery/exterior/2.jpg' },
            { url: '/assets/images/gallery/exterior/3.jpg' },
            { url: '/assets/images/gallery/exterior/4.jpg' },
            { url: '/assets/images/gallery/exterior/5.jpg' },
            { url: '/assets/images/gallery/exterior/6.jpg' },
            { url: '/assets/images/gallery/exterior/7.jpg' }
        ];
        _this.furnishedImages = [
            { url: '/assets/images/gallery/furnished/1.jpg' },
            { url: '/assets/images/gallery/furnished/2.jpg' },
            { url: '/assets/images/gallery/furnished/3.jpg' },
            { url: '/assets/images/gallery/furnished/4.jpg' },
            { url: '/assets/images/gallery/furnished/5.jpg' },
            { url: '/assets/images/gallery/furnished/6.jpg' },
            { url: '/assets/images/gallery/furnished/7.jpg' },
            { url: '/assets/images/gallery/furnished/8.jpg' },
            { url: '/assets/images/gallery/furnished/9.jpg' },
            { url: '/assets/images/gallery/furnished/10.jpg' },
            { url: '/assets/images/gallery/furnished/11.jpg' },
            { url: '/assets/images/gallery/furnished/12.jpg' },
            { url: '/assets/images/gallery/furnished/13.jpg' },
            { url: '/assets/images/gallery/furnished/14.jpg' },
            { url: '/assets/images/gallery/furnished/15.jpg' },
            { url: '/assets/images/gallery/furnished/16.jpg' },
            { url: '/assets/images/gallery/furnished/17.jpg' },
            { url: '/assets/images/gallery/furnished/18.jpg' },
            { url: '/assets/images/gallery/furnished/19.jpg' }
        ];
        _this.interiorImages = [
            { url: '/assets/images/gallery/interior/1.jpg' },
            { url: '/assets/images/gallery/interior/2.jpg' },
            { url: '/assets/images/gallery/interior/3.jpg' },
            { url: '/assets/images/gallery/interior/4.jpg' },
            { url: '/assets/images/gallery/interior/5.jpg' },
            { url: '/assets/images/gallery/interior/6.jpg' },
            { url: '/assets/images/gallery/interior/7.jpg' },
            { url: '/assets/images/gallery/interior/8.jpg' },
            { url: '/assets/images/gallery/interior/9.jpg' },
            { url: '/assets/images/gallery/interior/10.jpg' },
            { url: '/assets/images/gallery/interior/11.jpg' },
            { url: '/assets/images/gallery/interior/12.jpg' },
            { url: '/assets/images/gallery/interior/13.jpg' },
            { url: '/assets/images/gallery/interior/14.jpg' },
            { url: '/assets/images/gallery/interior/15.jpg' },
            { url: '/assets/images/gallery/interior/16.jpg' }
        ];
        return _this;
    }
    GalleryPageComponent.prototype.ngOnInit = function () {
        this.setTitle('Galerie foto Dream Residence - randari exterior si imagini interior.');
        this.setMetaDescription("\n      Iata cateva imagini care iti arata cat de frumos va fi sa locuiesti - pentru ca e intotdeauna minunat sa fii aproape de natura. Complex rezidential de calitate.\n    ");
    };
    GalleryPageComponent.prototype.open = function (images, index, event) {
        if (event)
            event.stopPropagation();
        if (this.window)
            this._lighboxConfig.positionFromTop = 20;
        var albums = [];
        for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
            var image = images_1[_i];
            var album = {
                src: image.url,
                thumb: image.url
            };
            albums.push(album);
        }
        this._lightbox.open(albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    GalleryPageComponent.prototype.isMobileSafari = function () {
        var is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent);
        var is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        return is_ios && is_safari;
    };
    return GalleryPageComponent;
}(SeoAwareBaseComponent));
export { GalleryPageComponent };



// WEBPACK FOOTER //
// ./src/app/gallery-page/gallery-page.component.ts.pre-build-optimizer.js